import { Get, Post, PostFormData, Put } from "../Request/Api";

export default {
  state: {
    Coupons: [],
  },
  getters: {
    GetCoupons(state: any) {
      return state.Coupons;
    },
  },
  actions: {
    async GetCoupons({ commit }: any, payload: any) {
      return await Get(`Coupon/GetCoupons`).then((res: any) => {
        commit("SetCoupons", res.data.Data);

        return res.data;
      });
    },
    async ValidateCoupon({ commit }: any, payload: any) {
      return await Get(
        `Coupon/ValidateCoupon?Code=${payload.Code}&Type=${payload.Type}`
      ).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetCoupons(state: any, payload: any) {
      state.Products = payload;
    },
  },
};
